import { render } from "./ssoForm.vue?vue&type=template&id=24ad84b8&scoped=true"
import script from "./ssoForm.vue?vue&type=script&lang=js"
export * from "./ssoForm.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=24ad84b8&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ad84b8"]])

export default __exports__